import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import { KEY_CODES } from '../constants';
export var Outside =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Outside, _React$Component);

  function Outside() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Outside);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Outside)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "rootRef", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "hasMouseUpListener", false);

    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function (e) {
      if (_this.isInnerTarget(e.target)) {
        return;
      }

      if (!_this.hasMouseUpListener) {
        document.addEventListener('mouseup', _this.handleMouseUp, false);
        _this.hasMouseUpListener = true;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseUp", function (e) {
      if (_this.hasMouseUpListener) {
        document.removeEventListener('mouseup', _this.handleMouseUp, false);
        _this.hasMouseUpListener = false;
      }

      if (_this.isInnerTarget(e.target)) {
        return;
      }

      _this.props.onOutside(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      var intKey = event.keyCode;

      if (intKey === KEY_CODES.ESC) {
        _this.props.onOutside();
      }
    });

    return _this;
  }

  _createClass(Outside, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleKeyDown, false);
      document.addEventListener('mousedown', this.handleMouseDown, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown, false);
      document.removeEventListener('mousedown', this.handleMouseDown, false);
      document.removeEventListener('mouseup', this.handleMouseUp, false);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("span", {
        ref: this.rootRef
      }, this.props.children);
    }
  }, {
    key: "isInnerTarget",
    value: function isInnerTarget(target) {
      var root = this.rootRef.current;
      return Boolean(root && target && root.contains(target));
    }
  }]);

  return Outside;
}(React.Component);